(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.creditLimit.grantTemporaryLimit',
      GrantTemporaryLimitModalController
    );

  GrantTemporaryLimitModalController.$inject = [
    '$uibModalInstance',
    'moment',
    'abp.services.app.creditLimit',
    'corporateId',
    'currencyCode',
  ];

  function GrantTemporaryLimitModalController(
    $uibModalInstance,
    moment,
    creditLimitSvc,
    corporateId,
    currencyCode
  ) {
    const vm = this;

    vm.saving = 0;
    vm.currencyCode = currencyCode;
    vm.amount = null;
    vm.expiryDate = null;
    vm.remarks = '';

    vm.save = save;
    vm.cancel = cancel;

    // Client-side checks mirror the server rules; the server remains the authority. A past expiry
    // date is left to the server: the date picker's min-date rejects any date typed by hand.

    function save() {
      // Enter can submit the form while a save is still running.
      if (vm.saving) return;

      if (!App.isFormValid(vm.grantTemporaryLimitForm)) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }

      // Send the expiry date as a date-only string so no time zone shift can move the day.

      vm.saving += 1;
      creditLimitSvc
        .grantTemporaryCreditLimit({
          corporateId,
          amount: vm.amount,
          expiryDate: moment(vm.expiryDate).format('YYYY-MM-DD'),
          remarks: vm.remarks,
        })
        .success((grant) => {
          abp.notify.success(
            App.localize('CreditLimit_TemporaryGrantCreated', grant.referenceNumber)
          );
          $uibModalInstance.close(true);
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
